<header>
    <div class="left">
        <button mat-button routerLink="/"><mat-icon>arrow_back</mat-icon> Dashboard</button>
    </div>

    <div class="right">
        <a target="_blank" href="https://app.squareup.com/dashboard/square-card/activity/transfers" mat-raised-button>Square</a>
    </div>
</header>


<div class="container">

    <ng-container *ngIf="!this.loading">
        <!-- <ng-container *ngIf="revenueAcc == 0">
            <div class="allgood">Nothing to sort out!!!</div>
        </ng-container> -->

        <div class="report content" *ngIf="revenueAcc != 0">
            <div>
                <h2>Expenses</h2> 
                <div>{{moveToExpenses | human}}</div>
            </div>

            <div>
                <h2>BAS Withholdings</h2> 
                <div>{{moveToGst | human}}</div>
            </div>

            <div>
                <h2>Business Savings</h2> 
                <div>{{moveToSavings | human}}</div>
            </div>

            <div>
                <h2>Wages</h2> 
                <div>{{moveToWages | human}}</div>
            </div>
        </div>

        <div class="g72RevenueBalance">{{g72RevenueBalance | human}}</div>
    
        <ng-container *ngIf="revenueAcc != 0">
            <h2>Pending Revenue</h2>

            <table *ngIf="revenueAcc != 0" class="invoices" mat-table [dataSource]="revenueAccDataSource" multiTemplateDataRows>
                
                <!-- Column Headers -->
                <ng-container matColumnDef="status">
                    <th class="status-header" mat-header-cell *matHeaderCellDef>Status</th>
                    <td class="status-column" mat-cell *matCellDef="let element">
                        <div class="status" [class]="element.status">{{element.status}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="date">
                    <th class="date" mat-header-cell *matHeaderCellDef>Date</th>
                    <td mat-cell *matCellDef="let element"> {{element['date'] | date:'dd-MM-yy'}} </td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th class="description" mat-header-cell *matHeaderCellDef>Description</th>
                    <td mat-cell *matCellDef="let element"> <span class="customer">{{element['customer']}}</span> {{element['description']}} <span class="note">{{element['note']}}</span></td>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <th class="amount" mat-header-cell *matHeaderCellDef>Amount</th>
                    <td class="amount" mat-cell *matCellDef="let element">
                        {{ element['amount'] | human }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="vat">
                    <th class="vat" mat-header-cell *matHeaderCellDef>GST</th>
                    <td class="vat" mat-cell *matCellDef="let element">
                        {{ element['vat'] | human }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                <tr class="invoice-row"
                    mat-row
                    (click)="openProofViewer(element.source.sha1, i, revenueAccDataSource)"
                    *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;">
                </tr>
            </table>

            <div class="revenue-actions">
                <button [disabled]="showMarkAsSortedButton" mat-raised-button color="primary" (click)="findInvoices();">Find Invoices</button>
                <button [disabled]="!showMarkAsSortedButton" mat-raised-button color="primary" (click)="commit();">Commit</button>
            </div>
        </ng-container>
    </ng-container>



    <div *ngIf="!this.loading" class="g72revenue">
        
        <table *ngIf="totalAmount != 0 || g72RevenueDataSource != undefined" class="invoices" mat-table [dataSource]="g72RevenueDataSource" multiTemplateDataRows>

            <!-- Column Headers -->
            <ng-container matColumnDef="status">
                <th class="status-header" mat-header-cell *matHeaderCellDef>Status</th>
                <td class="status-column" mat-cell *matCellDef="let element">
                    <div class="status" [class]="transactionStatus(element)">
                        {{transactionStatus(element)}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th class="date" mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element"> {{element['date'] | date:'dd-MM-yy'}} </td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th class="description" mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let element"> <span class="customer">{{element['customer']}}</span> {{element['description']}} <span class="note">{{element['note']}}</span></td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th class="amount" mat-header-cell *matHeaderCellDef>Amount</th>
                <td class="amount" mat-cell *matCellDef="let element">
                    {{ element['amount'] | human }}
                </td>
            </ng-container>

            <ng-container matColumnDef="vat">
                <th class="vat" mat-header-cell *matHeaderCellDef></th>
                <td class="vat" mat-cell *matCellDef="let element">
                    <div class="revenue-button-group">
                        <button mat-button [matMenuTriggerFor]="menu">Source</button>
                        <mat-menu #menu="matMenu">
                            <button mat-button (click)="openSquareDialog(element)">Square</button>
                            <button mat-button (click)="openEbayDialog(element)">Ebay</button>
                            <button mat-button (click)="openCashDialog(element)">Cash</button>
                        </mat-menu>
                        <button mat-button (click)="markAsSorted(element)">Mark as Sorted</button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr class="invoice-row"
                mat-row
                *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;">
            </tr>
        </table>
    </div>

</div>